import { render, staticRenderFns } from "./FiltroAreas.vue?vue&type=template&id=6e5f126a&scoped=true"
import script from "./FiltroAreas.vue?vue&type=script&lang=js"
export * from "./FiltroAreas.vue?vue&type=script&lang=js"
import style0 from "./FiltroAreas.vue?vue&type=style&index=0&id=6e5f126a&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f126a",
  null
  
)

export default component.exports